import { FOOTER } from "@/content";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-[#0A0F16] px-6 py-12 lg:px-10">
    <div className="mx-auto flex max-w-6xl flex-col items-start justify-between gap-4 md:flex-row md:items-center">
      <p className="font-serif text-lg tracking-tight text-[#F6F5F2]">Melanie Ann Collins</p>
      <p className="text-xs uppercase tracking-[0.2em] text-[#9AA6B2]">{FOOTER.line}</p>
    </div>
  </footer>
);
